import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import HC0124CompareProFeatureTableHeaderCell from './HC0124CompareProFeatureTableHeaderCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const THead = styled.thead.withConfig({
  displayName: "HC0124CompareProFeatureTableStaticHeader__THead",
  componentId: "sc-1imfh69-0"
})(["height:150px;vertical-align:bottom;& tr th:first-of-type{font-size:1.5rem;font-weight:600;text-align:left;line-height:100%;border:none !important;}"]);
const HC0124CompareProFeatureTableStaticHeader = ({
  levelsAndApiNames,
  upgradePointProductLevel,
  upgradePointApiName,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  feature
}) => {
  return /*#__PURE__*/_jsx(THead, {
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("th", {
        className: "p-bottom-3 p-left-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.productCatalog.tableHeader.features"
        })
      }), levelsAndApiNames.map((item, i) => {
        return /*#__PURE__*/_jsx(HC0124CompareProFeatureTableHeaderCell, {
          columns: levelsAndApiNames.length,
          productLevel: item.level,
          productLine: item.productLine,
          upgradePointProductLevel: upgradePointProductLevel,
          ownedProductColumn: i === 0,
          upgradePointApiName: upgradePointApiName,
          purchaseMotions: purchaseMotions,
          handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
          feature: feature
        }, item.level);
      })]
    })
  });
};
export default HC0124CompareProFeatureTableStaticHeader;